
import { defineComponent } from 'vue';
import LogoLimaTec from './LogoLimaTec.vue';
import { rolarPara } from '@/uteis/navegacao';

export default defineComponent({
name: 'FooterPagina',
components: {
    LogoLimaTec
},
methods: {
    rolarPara
},
props: {
    Titulo: {
        type: String,
        default: ""
    },
    LinkLinkedin: {
        type: String,
        default: ""
    },
    LinkFacebook: {
        type: String,
        default: ""
    },
    LinkInstagram: {
        type: String,
        default: ""
    }
},

});
